module.exports = __webpack_public_path__ + "img/candidate_current_placeholder.738afbe3.png";